export const blogsData = [
	{
		title: "Debouncing and Throttling",
		description:
			"Debouncing and Throttling are performance optimization techniques used to improve performance of a code that is executed repeatedly within a time frame...",
		publishedDate: "Jun 9, 2022",
		readTime: "3 min read",
		blogURL: "https://shreyassoni.hashnode.dev/debouncing-and-throttling",
	},
	{
		title: "Temporal Dead Zone",
		description:
			"ES6 introduced two new ways to declare variables const and let, which mostly replaces the old practice of using var. Let's briefly look into the difference between these three ways...",
		publishedDate: "Jan 11, 2022",
		readTime: "3 min read",
		blogURL: "https://shreyassoni.hashnode.dev/temporal-dead-zone",
	},
	{
		title: "What in the world is Nullish Coalescing??",
		description:
			"ES2020 introduced the nullish coalescing operator. As the name suggests nullish coalescing is used to handle null or undefined values...",
		publishedDate: "Jan 10, 2022",
		readTime: "3 min read",
		blogURL:
			"https://shreyassoni.hashnode.dev/what-in-the-world-is-nullish-coalescing",
	},
];
